import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";


async function requisicaoPay(rota, dados) {
    if (!JwtService.getToken()) return { resultado: false, erro: "Sessão expirada.", msg: "Entre novamente no Desk." };
    ApiService.setHeader();
    try { return (await ApiService.postOnce(rota, dados)).data; }
    catch (e) {
        const msg = e.response?.data?.erro || e.response?.data?.msg || e.response?.data?.message || "Operação sem confirmação. Consulte a situação antes de repetir.";
        return { resultado: false, erro: msg, msg, REGISTROS: [], QUANTIDADE: 0 };
    }
}

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getPayMaquininhasAll() {
        return requisicaoPay("payRecebedoresPos/access/listar", {});
    }, 
    getPayMaquininhas(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return requisicaoPay("payRecebedoresPos/access/listar", dados);
    }, 
    getPayMaquininha(context, dados) {
        return requisicaoPay("payRecebedoresPos/access/obter", { ID_PAY_RECEBEDOR_POS: dados.id, componente: dados.componente });
    }, 
    deletePayMaquininha(context, dados) {
        return requisicaoPay("payRecebedoresPos/access/excluir", { ID_PAY_RECEBEDOR_POS: dados.id, componente: dados.componente });
    }, 
    postPayMaquininha(context, dados) {
        return requisicaoPay("payRecebedoresPos/access/salvar", dados);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};